import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { t } from '../../../helpers/t';
import { default as bannerItems } from '../../../../../../../config/reassurance_banner_items';
import { Breakpoint } from '../../../helpers/MediaQuery';

function ReassuranceBanner() {
  return <section className="reassurance-banner px-2">
    <span className="my-2 grid gap-2 grid-cols-10">
      {[1, 0, 1, 2].map((v, idx) => (
        <span
          className={classNames(
            'reassurance p-4 bg-green-50 items-center flex flex-col rounded justify-center',
            v === 1 ? (idx === 0 ? 'col-span-10 lg:hidden' : 'col-span-4 hidden lg:flex') : 'col-span-5 lg:col-span-3',
          )}
          key={`bannerItems[v].message_${idx}`}>
          <span className="icon text-green-900 text-xl sm:text-3xl">
            <FontAwesomeIcon icon={bannerItems[v].icon} alt={bannerItems[v].message} />
          </span>
          <p
            className="text-green-800 font-light text-sm mb-0 mt-2 sm:mt-2 text-center"
            dangerouslySetInnerHTML={{ __html: t(bannerItems[v].translationKey) }}
          />
        </span>
      ))}
    </span>
  </section>
}

export default ReassuranceBanner;
